import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=37d0fd6a&scoped=true"
import script from "./AddressView.vue?vue&type=script&lang=js"
export * from "./AddressView.vue?vue&type=script&lang=js"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=37d0fd6a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d0fd6a",
  null
  
)

export default component.exports